import React, { useState } from "react";
import linkIcon from "./../assets/link-16.png";
import githubLogo from "./../assets/github-logo.png";
import spring from "./../logos/spring.png"
import react from "./../logos/react.png"
import docker from "./../logos/docker.png"
import redis from "./../logos/redis.png"
import psql from "./../logos/psql.png";
import { Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from "@nextui-org/react";

import Tictactoe from "./Projects/TicTacToe/Tictactoe-Home";
import DeliveryAppHome from "./Projects/DeliveryAppHome";
import TodoAppHome from "./Projects/TodoAppHome";

export default function ProjectCard(props) {

  const {isOpen, onOpen, onOpenChange} = useDisclosure();

  const techLogos = {
    react,
    docker,
    redis,
    spring,
    psql
  };




  return (
    <div className="rounded-xl bg-[#363636] w-full pb-6 max-w-[500px] hover:bg-gray-700" onClick={onOpen}>
      <img
        src={props.image}
        className="rounded-t-xl w-full h-64 object-cover"
      />

      <div className="rounded-b-xl flex flex-col gap-6 py-4 px-4  items-start">
        <p className="text-xl items-start">{props.title}</p>
        <p className="text-start">{props.summary}</p>
      </div>


      <div className=" justify-evenly py-2-px-2 flex">


        {props.tech?.map((tech, index) => (
          <img key={index} src={techLogos[tech]} className='h-10 w-15'/>
          // console.log(tech)
        ))}      




</div>
      <div className="flex justify-around py-2 px-2 items-start mt-8">
        <div className='flex gap-2 items-center'>
        <a href={props.link}>
          <img className={`${props.link != null ? 'flex' : 'hidden'}`} src={linkIcon} />
          </a>  
        </div>

          <div>
        <a href={props.githubLink}>
          <img src={githubLogo} className='h-6' />
          </a>  
        </div>
     </div>




     <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="4xl">

      <ModalContent className="h-3/4 w-full">
        {(onClose) => (
          
          <>
            <ModalHeader className="text-xl">{props.title}</ModalHeader>
           
           {props.title == "Websocket Tic Tac Toe" ? <Tictactoe/> : props.title == "Delivery Route Optimisation App" ? <DeliveryAppHome/> : props.title == "Todoly" ? <TodoAppHome/> : ""} 
          
          </>


        )}
      
      </ModalContent>

     </Modal>

    </div>
  );
}
